import { render, staticRenderFns } from "./DetailCenter.vue?vue&type=template&id=1d5653d5"
import script from "./DetailCenter.vue?vue&type=script&lang=js"
export * from "./DetailCenter.vue?vue&type=script&lang=js"
import style0 from "./DetailCenter.vue?vue&type=style&index=0&id=1d5653d5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports